import storageClient from '../services/Storage'

export default function(
  state = {
    profiles: {}, //Arrays are evil
    user: null,
    error: {
      login: null,
      register: null,
      forgot: null
    },
    success: {
      login: null,
      register: null,
      forgot: null
    },
    isLoggedIn: false,
    redirectURL: null,
    title: {
      label: 'Ebooks Patagonia',
      action: () => {},
      back: false
    }
  },
  action
) {
  switch (action.type) {
    case 'SAVE_REDIRECT_URL':
      return Object.assign({}, state, { redirectURL: action.payload })

    case 'ERROR':
      return {
        ...state,
        error: action.payload
      }

    case 'SUCCESS':
      return {
        ...state,
        success: action.payload
      }

    case 'LOGIN':
      storageClient.setItem('patagonia.user.data', action.payload, data => {
        console.log('LOGIN EN STORAGE OK')
      })

      return Object.assign({}, state, {
        isLoggedIn: true,
        user: action.payload,
        error: {
          login: null,
          register: null,
          forgot: null
        }
      })

    case 'LOGOUT':
      storageClient.removeItem('patagonia.user.data', () => {
        action.payload.callback()
      })

      return Object.assign({}, state, {
        isLoggedIn: false,
        user: null,
        userBooks: []
      })

    case 'REMOVE_PROFILE':
      //Quito del array de objetos el action.payload.key
      const profiles = Object.assign({}, state.profiles)

      delete profiles[action.payload.key]

      return {
        ...state,
        profiles: profiles
      }

    case 'FETCH_PROFILE':
      //Por si acaso si existe lo elimino:
      const profilesExisting = Object.assign({}, state.profiles)

      delete profilesExisting[action.payload.key]

      const profile = Object.assign({}, action.payload.object, {
        key: action.payload.key,
        thumb: 'http://www.nawang.com/Photos/10Logos/Profile_LOGO.jpg'
      })

      return {
        ...state,
        profiles: Object.assign({}, profilesExisting, {
          [action.payload.key]: profile
        })
      }

    case 'UPDATE_TITLE':
      return Object.assign({}, state, {
        title: {
          label: action.payload.label,
          action: action.payload.action,
          back: action.payload.back
        }
      })

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/index.js